import { takeLatest, call, put } from "redux-saga/effects";
import { CashFlowAction } from "../actions";
import * as types from "../actions/actionTypes";
import queryString from "query-string";
import moment from "jalali-moment";
import { createBrowserHistory } from "history";
import * as cashFlowApi from "../api/cashFlow";
import { toastr } from "react-redux-toastr";
import * as paymentApi from "../api/payment";
import * as receiveApi from "../api/receive";
import { PAYMENT, RECEIVE } from "../constants/accountReviewActionTypes";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

moment.locale("fa");

const RECEIVE_TYPE = RECEIVE;
const PAYMENT_TYPE = PAYMENT;

export function* watcherCashFlow() {
  yield takeLatest(types.CASH_FLOW_REQUEST, worker);
  yield takeLatest(types.REMOVE_CASH_FLOW_REQUEST, removeWorker);
}

async function fetchList(account_type, pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  const history = createBrowserHistory();
  const filters = {
    file_type: "web",
    end_date: "",
    start_date: "",
    account_type: account_type,
    sort_field: "date",
    sort_type: "desc",
    text_search: ""
  };
  let urlFilters = await queryString.parse(document.location.search);

  let parsed = {
    ...urlFilters,
    start_date: urlFilters.start_date || filters.start_date,
    end_date: urlFilters.end_date || filters.end_date,
    date_type: urlFilters.date_type || 3
  };
  if (urlFilters.date_type !== undefined) {
    switch (parseInt(urlFilters.date_type)) {
      case 1:
        parsed.start_date = moment()
          .subtract(1, "months")
          .local("fa")
          .format("YYYY/MM/DD");
        parsed.end_date = moment()
          .local("fa")
          .format("YYYY/MM/DD");
        break;
      case 2:
        parsed.start_date = moment()
          .local("fa")
          .format("YYYY/MM/DD");
        parsed.end_date = moment()
          .local("fa")
          .format("YYYY/MM/DD");
        break;
      default:
        parsed.start_date = urlFilters.start_date;
        parsed.end_date = urlFilters.end_date;
    }
  }
  parsed.start_date = parsed.start_date.split("/").join("-");
  parsed.end_date = parsed.end_date.split("/").join("-");
  const search = await queryString.stringify(parsed);
  const oldSearch = history.location.search.substring(
    1,
    history.location.search.length
  );
  // if (history.location.search !== '' && oldSearch !== search) {
  //   history.push({search: `?${search}`});
  // }

  urlFilters = {
    ...urlFilters,
    start_date: parsed.start_date.split("-").join("/"),
    end_date: parsed.end_date.split("-").join("/"),
    sort_field:
      urlFilters.sort_field !== undefined && urlFilters.sort_field !== ""
        ? urlFilters.sort_field
        : "date"
  };

  const finalFilter = { ...filters, ...urlFilters };

  return cashFlowApi.getList(page_number, finalFilter);
}

function* worker(action) {
  try {
    const response = yield call(
      fetchList,
      action.account_type,
      action.pageNumber
    );
    yield put(CashFlowAction.getSuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(CashFlowAction.getFailure(error));
  }
}

async function remove(id, type) {
  if (type === RECEIVE_TYPE) {
    return receiveApi.remove(id);
  } else if (type === PAYMENT_TYPE) return paymentApi.remove(id);
}

function* removeWorker(action) {
  try {
    const res = yield call(remove, action.id, action.account_type);
    res.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const response = yield call(
      fetchList,
      action.account_type,
      action.pageNumber
    );
    yield put(CashFlowAction.removeSuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(CashFlowAction.removeFailure());
  }
}
